import { msg } from "@lingui/core/macro";

export const TOKEN_NOT_FOUND_TEXT = msg({
  id: "ERROR_TokenNotFound",
  message: "Token not found",
});

export const SUBMITTING_TEXT = msg({
  id: "Common_submitting",
  message: "Submitting...",
});

export const CANCELLING_TEXT = msg({
  id: "Common_cancelling",
  message: "Cancelling...",
});

export const DONE_TEXT = msg({
  id: "Common_done",
  message: "Done",
});

export const SUBMIT_TEXT = msg({
  id: "Common_submit",
  message: "Submit",
});

export const LOADING_TEXT = msg({
  id: "Common_loading",
  message: "Loading...",
});

export const COPIED_TO_CLIPBOARD_TEXT = msg({
  id: "Common_copied_to_clipboard",
  message: "Copied to clipboard!",
});

export const CONFIRM_TEXT = msg({
  id: "Common_confirm",
  message: "Confirm",
});

export const CLOSE_TEXT = msg({
  id: "Common_close",
  message: "Close",
});

export const COPY_TO_CLIPBOARD_ARIA_LABEL = msg({
  id: "Common_copy_to_clipboard_aria",
  message: "Copy to clipboard",
});

export const PASSWORD_LABEL = msg({
  id: "Common_password",
  message: "Password",
});

export const OTP_LABEL = msg({
  id: "Common_otp",
  message: "OTP",
});

export const AUTH_SEND_EMAIL_TEXT = msg({
  id: "Auth_send_email",
  message: "Send email",
});

export const AUTH_ENTER_EMAIL_ERROR_TEXT = msg({
  id: "Auth_enter_email_error",
  message: "Please enter an email address.",
});

export const AUTH_EMAIL_SENT_TOAST_TEXT = msg({
  id: "Auth_email_sent_toast",
  message: "An email has been sent to you.",
});

export const AUTH_LOGIN_INSTEAD_TEXT = msg({
  id: "Auth_log_in_instead",
  message: "Log in Instead?",
});

export const AUTH_LOGIN_INSTEAD_ALT_TEXT = msg({
  id: "Auth_login_instead",
  message: "Login Instead?",
});

export const AUTH_PASSWORDS_DO_NOT_MATCH_TEXT = msg({
  id: "Auth_passwords_do_not_match",
  message: "Passwords do not match",
});

export const AUTH_PASSWORD_TOO_SHORT_TEXT = msg({
  id: "Auth_password_too_short",
  message: "Password must be at least 8 characters.",
});

export const AUTH_PASSWORD_TOO_LONG_TEXT = msg({
  id: "Auth_password_too_long",
  message: "Password must be at most 128 characters.",
});

export const FORM_STATE_LABEL = msg({
  id: "Form_state_label",
  message: "State",
});

export const ORDER_STATUS_SHIPPED_TO_YOU_TEXT = msg({
  id: "Order_status_shipped_to_you",
  message: "Shipped to you",
});

export const FIRST_NAME_LABEL = msg({
  id: "User_first_name_label",
  message: "First Name",
});

export const LAST_NAME_LABEL = msg({
  id: "User_last_name_label",
  message: "Last Name",
});

export const EMAIL_LABEL = msg({
  id: "User_email_label",
  message: "Email",
});

export const PHONENUMBER_LABEL = msg({
  id: "User_phonen_umber_label",
  message: "Phone number",
});

export const NO_PHONE_NUMBBER_LABEL = msg({
  id: "User_phone_number_none_label",
  message: "N/A",
});

export const SAVE_TEXT = msg({
  id: "User_save",
  message: "Save",
});

export const DISCARD_TEXT = msg({
  id: "User_discard",
  message: "Discard",
});

export const EDIT_NAME_ARIA_LABEL = msg({
  id: "User_edit_name_aria_label",
  message: "Edit name button",
});

export const ERROR_TOAST_TITLE = msg({
  id: "Toast_error_title",
  message: "Error",
});

export const SUCCESS_TOAST_TITLE = msg({
  id: "Toast_success_title",
  message: "Success",
});

export const WARNING_TOAST_TITLE = msg({
  id: "Toast_warning_title",
  message: "Uh oh",
});

export const INFO_TOAST_TITLE = msg({
  id: "Toast_info_title",
  message: "Heads up!",
});

export const LUNAR_NEW_YEAR_TOAST_TITLE = msg({
  id: "Toast_lunar_new_year_title",
  message: "Happy Lunar New Year!",
});

export const LUNAR_NEW_YEAR_TOAST_DESCRIPTION = msg({
  id: "Toast_lunar_new_year_description",
  message:
    "Wooting's Taiwan Office will close for the Lunar New Year period from  8 Feb to 16 Feb. Response times may be slower than usual. We appreciate your patience. 新年快乐",
});

export const UNEXPECTED_ERROR_TEXT = msg({
  id: "Error_unexpected",
  message: "An unexpected error occurred.",
});

export const AUTH_INVALID_EMAIL_TEXT = msg({
  id: "Auth_error_invalid_email",
  message: "Email address not correctly formatted. Please check and try again.",
});

export const AUTH_INCORRECT_CREDENTIALS_TEXT = msg({
  id: "Auth_error_incorrect_credentials",
  message: "Incorrect email or password. Please check and try again.",
});

export const AUTH_TOO_MANY_REQUESTS_TEXT = msg({
  id: "Auth_error_too_many_requests",
  message: "You're submitting too fast! Please wait a moment.",
});

export const AUTH_SERVER_CONNECTION_FAILED_TEXT = msg({
  id: "Auth_error_server_connection_failed",
  message: "Failed to connect to server. Please wait a moment.",
});

export const AUTH_LOGIN_CREDENTIALS_FAILED_TEXT = msg({
  id: "Auth_error_login_credentials_failed",
  message: "Failed to login with given credentials. Are they correct?",
});

export const AUTH_LOGIN_SERVER_ERROR_TEXT = msg({
  id: "Auth_error_login_server_error",
  message: "Failed to login due to a server issue. Please try again later.",
});

export const AUTH_CHANGE_PASSWORD_FAILED_TEXT = msg({
  id: "Auth_error_change_password_failed",
  message: "Changing Password failed. Please try again.",
});

export const AUTH_CHANGE_EMAIL_FAILED_TEXT = msg({
  id: "Auth_error_change_email_failed",
  message: "Changing Email failed. Please try again.",
});

export const ORDER_NOT_FOUND_TEXT = msg({
  id: "Order_not_found",
  message: "Order could not be found with given order number",
});

export const SHIPPING_ADDRESS_UPDATED_TEXT = msg({
  id: "Shipment_address_updated_toast",
  message: "Shipping address updated!",
});

export const FORM_FIELD_REQUIRED_TEXT = msg({
  id: "Form_field_required",
  message: "This field is required",
});

export const FORM_FIELD_LATIN_CHARACTERS_TEXT = msg({
  id: "Form_field_latin_characters",
  message: "This field must be in Latin characters",
});

export const FORM_FIELD_CHINESE_CHARACTERS_TEXT = msg({
  id: "Form_field_chinese_characters",
  message: "This field must be in Chinese",
});

export const FORM_COMPANY_LABEL = msg({
  id: "Form_company_label",
  message: "Company",
});

export const FORM_POSTAL_CODE_LABEL = msg({
  id: "Form_postal_code_label",
  message: "Postal Code",
});

export const FORM_ADDRESS_1_LABEL = msg({
  id: "Form_address_1_label",
  message: "Address 1",
});

export const FORM_ADDRESS_2_LABEL = msg({
  id: "Form_address_2_label",
  message: "Address 2",
});

export const FORM_CITY_LABEL = msg({
  id: "Form_city_label",
  message: "City",
});

export const FORM_PHONE_LABEL = msg({
  id: "Form_phone_label",
  message: "Phone",
});

export const FORM_STATE_PROVINCE_LABEL = msg({
  id: "Form_state_province_label",
  message: "State / Province",
});

export const FORM_COUNTRY_LABEL = msg({
  id: "Form_country_label",
  message: "Country",
});

export const FORM_ADDRESS_LINE_1_LABEL = msg({
  id: "Form_address_line_1_label",
  message: "Address Line 1",
});

export const FORM_ADDRESS_LINE_2_LABEL = msg({
  id: "Form_address_line_2_label",
  message: "Address Line 2",
});

export const FORM_STREET_ADDRESS_SUBTEXT = msg({
  id: "Form_street_address_subtext",
  message: "Street Address + Number",
});

export const FORM_APARTMENT_SUBTEXT = msg({
  id: "Form_apartment_subtext",
  message: "Apartment / Suite / PO Box",
});
